import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SERVICE_TYPES } from '@bagonboard/wiseman';
// core components
import CardBody from '../../../components/Card/CardBody';
import NavPills from '../../../components/NavPills/NavPills';
import Snackbar from '../../../components/Snackbar/Snackbar';

import * as actions from '../../../reducers/Service/actions';

import {
  AddPassenger,
  AgentInstructions,
  ContactLuggage,
  FlightPnr,
  Footer,
  Header,
  PassengerBags,
  Agent,
  PickupDelivery,
  TopContainer,
} from './components';

import {
  CardWrapper,
  Container,
} from './style';
import { historyPropTypes } from '../../../types';

const {
  CHECKIN,
} = SERVICE_TYPES;

const emptyOnConfirm = () => {
  // NOTE: This function was created due to SweetAlert onConfirm required prop
  // Think about replacing SweetAlert for other component since it's only used as an Spinner.
};

export class Service extends Component {
  componentDidMount() {
    const {
      match: {
        params: { id },
      },
      serviceFetch,
    } = this.props;

    serviceFetch(id);
  }

  render() {
    const {
      agents,
      assignAgentToService,
      history,
      match: { params },
      service,
    } = this.props;
    const {
      _id,
      agent,
      areas,
      bagComment,
      bags,
      code,
      deliverySlot,
      deliveryTime,
      flightInfo,
      from,
      order,
      paxs = [],
      pickupSlot,
      pickupTime,
      status,
      to,
      type,
    } = service.data;

    const {
      _id: orderId,
      bookingCode,
      customer,
    } = order || {};

    return (
      <>
        <Container>
          <TopContainer
            bookingCode={bookingCode}
            history={history}
            orderId={orderId}
            biometric={service?.data?.biometric}
          />
          <CardWrapper>
            <CardBody>
              <Header
                from={from}
                history={history}
                serviceCode={code}
                status={status}
                type={type}
              />
              <NavPills
                color="info"
                tabs={[
                  {
                    key       : 'service',
                    tabButton : 'SERVICE',
                    tabContent: (
                      <>
                        <PickupDelivery
                          areas={areas}
                          deliverySlot={deliverySlot}
                          deliveryTime={deliveryTime}
                          flightInfo={flightInfo}
                          from={from}
                          id={_id}
                          pickupSlot={pickupSlot}
                          pickupTime={pickupTime}
                          to={to}
                          type={type}
                        />
                        <ContactLuggage
                          bagComment={bagComment}
                          bags={bags}
                          customer={customer}
                          paxs={paxs}
                        />
                        <FlightPnr
                          flightInfo={flightInfo}
                          id={_id}
                          isCheckin={type === CHECKIN}
                          paxs={paxs}
                        />
                        <Agent
                          areas={areas}
                          agents={agents}
                          assignAgentToService={assignAgentToService}
                          id={_id}
                          value={agent}
                        />
                        <AgentInstructions />
                      </>
                    ),
                  },
                  {
                    key       : 'passenger',
                    tabButton : 'PASSENGER & BAGS',
                    tabContent: (
                      <>
                        {paxs.map(pax => (
                          <PassengerBags
                            id={_id}
                            isCheckin={type === CHECKIN}
                            key={pax._id}
                            order={order}
                            pax={pax}
                            paxs={paxs}
                            status={status}
                          />
                        ))}
                        <AddPassenger
                          id={_id}
                          isCheckin={type === CHECKIN}
                          paxs={paxs}
                          status={status}
                        />
                      </>
                    ),
                  },
                ]}
              />
              <Footer id={params.id} status={status} />
            </CardBody>
          </CardWrapper>
        </Container>
        <SweetAlert
          confirmBtnStyle={{ display: 'none' }}
          show={service.loading}
          title=""
          onConfirm={emptyOnConfirm}
        >
          <CircularProgress />
        </SweetAlert>
        <Snackbar color="danger" message={service.error || ''} open={!!service.error} />
      </>
    );
  }
}
Service.propTypes = {
  agents              : PropTypes.shape({}),
  assignAgentToService: PropTypes.func,
  history             : historyPropTypes.isRequired,
  match               : PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
  serviceFetch: PropTypes.func,
  service     : PropTypes.shape({
    data: PropTypes.shape({
      _id         : PropTypes.string,
      agent       : PropTypes.string,
      areas       : PropTypes.array,
      bagComment  : PropTypes.string,
      bags        : PropTypes.number,
      code        : PropTypes.string,
      deliverySlot: PropTypes.number,
      deliveryTime: PropTypes.string,
      flightInfo  : PropTypes.shape({}),
      from        : PropTypes.shape({}),
      order       : PropTypes.shape({
        _id        : PropTypes.string,
        bookingCode: PropTypes.string,
        customer   : PropTypes.shape({}),
      }),
      paxs      : PropTypes.array,
      pickupSlot: PropTypes.number,
      pickupTime: PropTypes.string,
      status    : PropTypes.string,
      to        : PropTypes.shape({}),
      type      : PropTypes.string,
      biometric : PropTypes.shape({}),
    }),
    loading: PropTypes.bool,
    error  : PropTypes.string,
  }),
};

Service.defaultProps = {
  agents              : {},
  assignAgentToService: () => {},
  match               : {},
  serviceFetch        : () => {},
  service             : {
    order: {},
  },
};

const mapStateToProps = ({ agents, service }) => ({
  agents,
  service,
});

const mapDispatchToProps = dispatch => ({
  assignAgentToService: id => dispatch(actions.assignAgentToService(id)),
  serviceFetch        : id => dispatch(actions.serviceFetch(id)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Service);
